import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  EnrollmentFormSubmissionStatus,
  IEnrollmentForm
} from '@dadohr/shared/domainTypes/enrollmentForms';
import { IExperienceTemplate } from '@dadohr/shared/domainTypes/experience';
import { CountBubble } from '../../../../../components/CountBubble';
import { useCurrentUser } from '../../../../../services/currentUser';
import {
  useEnrollmentFormByTemplateOrGetEmptyDefault,
  useEnrollSubmissionById
} from '../../../../../services/experiences/enrollmentForms';
import { useMappedLoadingValue } from '../../../../../services/firebase';

const Inner = ({
  form
}: {
  form: Doc<IEnrollmentForm>;
  onViewSubmissions?: () => void;
}) => {
  const [ds] = useMappedLoadingValue(
    useEnrollSubmissionById(form.id, form.data.orgId),
    (ss) =>
      ss.filter((s) => s.data.status === EnrollmentFormSubmissionStatus.PENDING)
  );
  if (!ds || !ds.length) {
    return null;
  }

  return <CountBubble value={ds.length} color="yellow" />;
};

export const EnrollmentFormSubmissionsPendingBubble = ({
  tpl
}: {
  tpl: Doc<IExperienceTemplate>;
}) => {
  const currentUser = useCurrentUser();

  const [d] = useEnrollmentFormByTemplateOrGetEmptyDefault(tpl, currentUser.id);
  if (!d) {
    return null;
  }

  return <Inner form={d} />;
};
